
import { useState } from 'react';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import DashboardStats from './components/DashboardStats';
import QuickActions from './components/QuickActions';
import RecentActivities from './components/RecentActivities';

export default function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onMenuClick={() => setSidebarOpen(true)} />
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <main className="lg:ml-64 pt-16">
        <div className="p-4 sm:p-6">
          <div className="mb-6 sm:mb-8">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Tableau de Bord</h1>
            <p className="text-sm sm:text-base text-gray-600">Vue d'ensemble de votre activité</p>
          </div>

          <DashboardStats />
          
          <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 sm:gap-6 mt-6 sm:mt-8">
            <div className="xl:col-span-2">
              <RecentActivities />
            </div>
            <div>
              <QuickActions />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
